import { autoinject, bindable } from 'aurelia-framework';
import { values } from 'lodash';
import { AppSettings } from "./appsettings";
import * as Pikaday from 'pikaday';
import * as moment from 'moment';
const MarkdownIt = require('markdown-it');
//declare const Tooltip;

@autoinject
export class SetClassCustomAttribute {
	value: any;

	constructor(private element: Element) { }

	valueChanged(newValue, oldValue) {
		this.updateClasses();
	}

	updateClasses() {
		if (!this.value) {
			return;
		}

		let classNames = this.element.className;
		for (const property in this.value) {
			if (this.value.hasOwnProperty(property)) {
				classNames = classNames.replace(property, "").trim();

				if (this.value[property]) {
					classNames += " " + property;
				}
			}
		}

		this.element.className = classNames;
	}
}

@autoinject
export class ShowForRolesCustomAttribute {

	value: string;
	element: HTMLElement;

	constructor(element: Element) {
		this.element = (element instanceof HTMLElement) ? <HTMLElement>element : null;
	}

	valueChanged(newValue, oldValue) {
		this.updateVisibility();
	}

	updateVisibility() {
		if (!this.value || !this.element) {
			return;
		}

		const roles = this.value.split(',');
		if (roles.some(role => AppSettings.roles.indexOf(role) >= 0)) {
			this.element.style.removeProperty("display");
		} else {
			this.element.style.display = "none";
		}
	}
}

@autoinject
export class HideForRolesCustomAttribute {

	value: string;
	element: HTMLElement;

	constructor(element: Element) {
		this.element = (element instanceof HTMLElement) ? <HTMLElement>element : null;
	}

	valueChanged(newValue, oldValue) {
		this.updateVisibility();
	}

	updateVisibility() {
		if (!this.value || !this.element) {
			return;
		}

		const roles = this.value.split(',');
		if (roles.some(role => AppSettings.roles.indexOf(role) >= 0)) {
			this.element.style.display = "none";
		} else {
			this.element.style.removeProperty("display");
		}
	}
}


@autoinject
export class CollapsibleCustomAttribute {
	@bindable expanded: boolean;
	@bindable refresh: boolean;	

	constructor(private element: Element) { }

	expandedChanged(newValue) {
		this.updateMaxHeight(newValue);
	}

	refreshChanged(newValue: boolean) {
		if (newValue === true) {
			this.updateMaxHeight(this.expanded);
			setTimeout(() => { this.refresh = false; }, 0);
		}
	}

	updateMaxHeight(expanded: boolean) {
		const childrenTotalHeight = values(this.element.childNodes)
			.reduce((acc, val: HTMLElement) => acc as number + (val.clientHeight || 0), 0);

		if (expanded) {
			(this.element as HTMLElement).style.maxHeight = `${childrenTotalHeight}px`;
		} else {
			(this.element as HTMLElement).style.maxHeight = '0';
		}
	}
}

@autoinject
export class TooltipCustomAttribute {

	value: string;
	element: HTMLElement;
	
	constructor(element: Element) {
		this.element = element as HTMLElement;
	}

	valueChanged(newValue) {
		this.element.title = newValue;
		new window['bsn'].Tooltip(this.element);
	}

}

@autoinject
export class DateInputCustomAttribute {
	element: HTMLElement;
	pikaday : Pikaday;

	constructor(element: Element){
		this.element = element as HTMLElement;
	}	

	attached(){
		var localeData = moment().locale('fi-FI').localeData();
		
		var i18n = { previousMonth: null, nextMonth: null, months: localeData.months(), weekdays: localeData.weekdays(), weekdaysShort: localeData.weekdaysShort() };
		
		this.pikaday = new Pikaday({ field: this.element, firstDay: 1, format: 'D.M.YYYY', i18n: i18n });
	}

	detached(){
		if(this.pikaday){
			this.pikaday.destroy();
		}
	}

}

@autoinject
export class FormatMarkdownCustomAttribute {
	private md: typeof MarkdownIt;
	
	constructor(private element: Element) { 
		this.md = new MarkdownIt('default', {
			breaks: true,
			html: true
		})
	}
	
	valueChanged(newValue) {
		if (newValue) {
			this.element.innerHTML = this.md.render(newValue);
		}
	}
}
